import { api } from "@/api/client";

export type Company = {
  companyId: string;
  companyName: string;
};

export type Division = {
  divisionId: string;
  divisionName: string;
};

export function getCompaniesFromQualifier() {
  return api.get<Company[]>("company/qualifier");
}

export function getCompaniesFromCoordinator() {
  return api.get<Company[]>("company/coordinator");
}

export function getDivisionsFromQualifier(companyId: string) {
  return api.get<Division[]>(`company/qualifier/${companyId}/divisions`);
}
